

export const handleChangeErrors = (name, value, estadoCampoReque, setEstadoCampoReque,setEstadosActualizados) => {

  let nuevoEstadoCampoReque = { ...estadoCampoReque };


  console.log("name", name);
  console.log("value", value);

  if (value == '') {
    nuevoEstadoCampoReque[name] = true;
  } else {
    nuevoEstadoCampoReque[name] = false;
  }
  console.log("nuevoEstadoCampoReque", nuevoEstadoCampoReque);


  setEstadoCampoReque(nuevoEstadoCampoReque);

  setEstadosActualizados(false);


};



export const handleSubmitErrors = (
  formData,
  estadoCampoReque,
  setEstadoCampoReque,
  camposRequeridos,
  categoriaHabilitado,
  setEstadosActualizados
) => {
  let nuevoEstadoCampoReque = { ...estadoCampoReque };


  if(formData.id_categoria == 4){
    nuevoEstadoCampoReque["subcategoriaId"] = false;
  }

  for (const campo in camposRequeridos) {
    if (!formData[campo] || formData[campo].length == 0 && estadoCampoReque[campo]) {
      nuevoEstadoCampoReque[campo] = true;
    }else if(estadoCampoReque[campo]) {
      nuevoEstadoCampoReque[campo] = false;
    }
  }


  if (formData["temario_pdf"] || formData["anexo_pdf"]) {
    nuevoEstadoCampoReque["anexo_url"] = false;
    nuevoEstadoCampoReque["temario_url"] = false;
    nuevoEstadoCampoReque["temario_pdf"] = false;
    nuevoEstadoCampoReque["anexo_pdf"] = false;
  }

  if (formData["temario_url"] || formData["anexo_url"]) {
    nuevoEstadoCampoReque["temario_pdf"] = false;
    nuevoEstadoCampoReque["anexo_pdf"] = false;
    nuevoEstadoCampoReque["anexo_url"] = false;
    nuevoEstadoCampoReque["temario_url"] = false;
  }


  if (categoriaHabilitado.anexo_pdf === false) {
    nuevoEstadoCampoReque["anexo_pdf"] = false;
  }

  if (categoriaHabilitado.nivel === false) {
    nuevoEstadoCampoReque["nivel"] = false;
  }
  console.log("categoriaHabilitado.tieneSub ",categoriaHabilitado.tieneSub);
  if (categoriaHabilitado.tieneSub === false) {
    nuevoEstadoCampoReque["subcategoriaId"] = false;
  }


  setEstadoCampoReque(nuevoEstadoCampoReque);
  console.log("Nuevo estado de los campos requeridos:", nuevoEstadoCampoReque);

  setEstadosActualizados(true);
};

export const todosDatosCorrectos = (formData, estadoCampoReque) => {


  console.log("estadoCampoReque", estadoCampoReque);
  const formDataVacio = Object.values(formData).every(value => value === '');


  let todosCamposFalse = () => {
    const todosRequeFalse = Object.values(estadoCampoReque).every(valor => valor === false && !formDataVacio);

    return todosRequeFalse;
  };



  return {
    todosCamposFalse
  };
}